module.exports = __webpack_public_path__ + "static/media/BRITANNIA.6b41a334.txt";